import { Component, OnInit } from '@angular/core';
import { CmsService } from '../../core/services/cms.service';
import { StaticContentService } from '../static-content/static-content.service';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { BUID, CacheConstant, CacheDuration, CMSPages, CMSTemplateNames, UserDeviceConstant } from '../../../app/core/constants/app.constant';
import { CmsContent, CmsContentField, ContentStructureDetails, StaticPageContent } from '../../../app/shared/models/cms';
import * as _ from 'lodash';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BaseComponent } from '../../../app/app.base.component';
import { AppConfigService } from '../../../app/core/services/init/app-config.service';
 
 
 
@Component({
  selector: 'par-major-news',
  templateUrl: './major-news.component.html',
  styleUrls: ['./major-news.component.scss']
})
export class MajorNewsComponent extends BaseComponent  implements OnInit {


  companyNews : any[] = [];
  productRecalls: any[] = [];
  cmsPageName: any;
  templateNum: any;
  sequenceNum: any
  sequenceNo: number;
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  isAuthenticated: boolean = false;
  buId = this.envProperties.buId;
  
  showFull = false;
  visibleCount : number=3;
  // initialCount: number =3;
  expanded: boolean[]=[];
  contentNum : any;
  expand:  boolean[]=[];
  recallsCount: number= 6;
  // countInitial : number= 4;
    newsContent:  any[] = [];
    newsPrimary: any[] = [];
    
   
 
 
  constructor(
    private cmsService: CmsService,
    private staticContentService: StaticContentService,
    private cache: AppCacheService,
    private sanitizer: DomSanitizer,
    deviceDetectorService: DeviceDetectorService,
    private appConfig: AppConfigService,
  ){ 
      super(deviceDetectorService, cache, appConfig);
  }
 
 
  ngOnInit(): void {
    this.getNewsPageData();
  }

  getNewsPageData(){
    if (this.isMobileDevice() && this.websiteName == 'Major') {
        this.cmsPageName = this.isAuthenticated ? CMSPages.Mobile_Home : CMSPages.Mobile_Login;
    }
     else
    this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
    let sequenceNum = this.envProperties.cmsPageConfigVO.newsSeqNo;
 
    this.cmsService.getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum, sequenceNum).subscribe((response: any) => {
      if (!response.hasError && response.length > 0){
         this.newsContent = response;
          this.newsContent.forEach((cta: CmsContent) =>{
            cta.contentStructure = JSON.parse(cta.contentStructure);
          });
          this.newsContent.sort((a, b) => b.contentNum - a.contentNum);
           this.newsContent.forEach((cta: any) =>{
            if (cta.contentName === CMSTemplateNames.Web_News + " 1"  || cta.contentName == CMSTemplateNames. Mobile_News +" 1" ) {
                 this.newsPrimary = cta.contentStructure.recordList;
            } else if (cta.contentName === CMSTemplateNames.Web_News + " 2"  || cta.contentName == CMSTemplateNames. Mobile_News +" 2" ) {
                this.companyNews = cta.contentStructure.recordList;
            } else if (cta.contentName === CMSTemplateNames.Web_News + " 3"  || cta.contentName == CMSTemplateNames. Mobile_News +" 3" ) {
                this.productRecalls = cta.contentStructure.recordList;
            }
        });
    }
    })
  }
  get allShown(): boolean {
    return this.visibleCount >= this.companyNews.length 
  }
  get allShow(): boolean {
    return this.recallsCount >= this.productRecalls.length
  }



  showMore():void {
    this.visibleCount = this.allShown ? 3: Math.min(this.visibleCount + 3 , this.companyNews.length)
  }
  recallsMore():void {
    this.recallsCount = this.allShow ? 6: Math.min(this.recallsCount + 5 , this.productRecalls.length)
    
  }
 
	// truncated(html:any,maxLength:number):SafeHtml{
  //     const div= document.createElement('div')
  //     div.innerHTML =html;
  //     const text =div.textContent || div.innerText ||'';
  //     const truncated =text.length>maxLength ?text.slice(0,maxLength) +'...' :text;
  //     return `<div>${truncated}</div>`;
  // }
  truncated(html: string, maxLength: number): string {
  const div = document.createElement('div');
  div.innerHTML = html;
 
  let charCount = 0;
  let reachedLimit = false;
 
  function truncateNode(node: Node): Node | null {
    if (reachedLimit) return null;
 
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent || '';
      if (charCount + text.length <= maxLength) {
        charCount += text.length;
        return node.cloneNode();
      } else {
        const truncatedText = text.slice(0, maxLength - charCount) + '...';
        reachedLimit = true;
        return document.createTextNode(truncatedText);
      }
    }
 
    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as HTMLElement;
      const clone = element.cloneNode(false) as HTMLElement;
 
      for (const child of Array.from(node.childNodes)) {
        const truncatedChild = truncateNode(child);
        if (truncatedChild) {
          clone.appendChild(truncatedChild);
        }
        if (reachedLimit) break;
      }
 
      return clone;
    }
 
    return null;
  }
 
  const result = document.createElement('div');
 
  for (const child of Array.from(div.childNodes)) {
    const truncated = truncateNode(child);
    if (truncated) {
      result.appendChild(truncated);
    }
    if (reachedLimit) break;
  }
 
  return result.innerHTML;
 }

	toggle(index:number){
	this.expanded[index]=!this.expanded[index];
	}
  navigateToTargetLink(cmsContentLinkObj: any) {
    if (!_.isEmpty(cmsContentLinkObj)) {
         this.cmsService.redirectBasedOnLinkType(cmsContentLinkObj);
    }
  }
  recalls(index:number){
	this.expand[index]=!this.expand[index];
  }
 
}